// extracted by mini-css-extract-plugin
export default {"root":"as_ltzsvKjUM_dt1oSYg"};